import { createContext } from 'react';
import NumberFormatter from '../helper/NumberFormatter';

export type Texts = {
  buttonTable: string;
  buttonChart: string;
};

export type LocaleContextProps = {
  locale: string;
  formatter: NumberFormatter;
  texts: Texts
};

export const createLocaleContext = (locale: string, texts: Texts): LocaleContextProps => (
  {
    locale,
    formatter: new NumberFormatter(locale),
    texts,
  }
);

export const LocaleContext = createContext(null as LocaleContextProps);
